/**
 * Company details for Torsbo Handels AB.
 * Locale-independent facts (name, address, hours, social profiles) live here so
 * the footer, contact page and structured data all read from one source.
 */
export const COMPANY = {
  legalName: 'TORSBO HANDELS AB',
  displayName: 'Torsbo Handels AB',
  email: 'info@torsbohandels.com',
  phone: '0321-68 58 00',
  street: 'Torsbo 301',
  postalCode: 'SE-523 60',
  city: 'Gällstad',
  orgNr: 'SE-556047-7225',
  /**
   * Google Maps embed for the shop, used by the `map` PageBuilder content type.
   *
   * This is the keyless "Share → Embed a map" URL (`/maps/embed?pb=…`), NOT the
   * Maps Embed API (`/maps/embed/v1/place?key=…`) — the opaque `pb` blob carries
   * the camera and place, so no API key exists or is needed. Carried over from
   * the old Magento "Hitta till oss" CMS page. Regenerate via Share → Embed a
   * map on maps.google.com if the framing ever needs to change.
   */
  mapEmbedUrl:
    'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d4272.893627377338!2d13.4553259!3d57.6238891!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x465078cdc914745f%3A0xdc973dd4c10221bc!2sTorsbo%20Handels%20AB!5e0!3m2!1sen!2s!4v1583229129193!5m2!1sen!2s',
} as const;

/**
 * Opening hours — the FALLBACK only.
 *
 * The source of truth is the `opening_hours` CMS block, so staff can change a
 * Saturday without a deploy (see lib/opening-hours.ts). These constants render
 * when that block is missing, empty or unparseable, which keeps the footer
 * showing last-known-good hours instead of an empty column. Keep them roughly
 * current; they are what a customer sees if the CMS lookup fails.
 *
 * `label` is a translation key under `footer.hours`.
 */
export const OPENING_HOURS = [
  { label: 'weekdays', time: '09.00 - 18.00' },
  { label: 'tuesday', time: '13.00 - 18.00' },
  { label: 'saturday', time: '09.00 - 12.00' },
  { label: 'lunch', time: '12.00 - 13.00' },
] as const;

export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/torsbohandels',
  instagram: 'https://www.instagram.com/torsbohandelsab/',
} as const;
